// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-wrapper[data-v-60615e2c] {\n  width: 100%;\n}\n.avatar-wrapper .upload[data-v-60615e2c] {\n  margin-top: 15px;\n  margin-left: 25px;\n}\n.cropper-wrapper[data-v-60615e2c] {\n  height: 350px;\n}\n.accountImg[data-v-60615e2c] {\n  width: 200px;\n  height: 200px;\n  margin: 35px 0 55px 105px;\n  overflow: hidden;\n  border-radius: 50%;\n}\n.accountImg img[data-v-60615e2c] {\n  border-radius: 50%;\n}", ""]);
// Exports
module.exports = exports;
